import { createAction } from '@reduxjs/toolkit'

export const toggleMenuDisplay = createAction<{
  isDisplay: boolean
}>('menu/toggleMenuDisplay')
